<script setup>
import { computed, ref } from 'vue'
import { useSortable } from '@dnd-kit/vue/sortable'
import { CircleClose } from '@element-plus/icons-vue'

const props = defineProps({
  rookie: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  group: {
    type: String,
    required: true,
  },
  cdnUrl: {
    type: String,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['remove', 'select'])

const element = ref(null)
const handle = ref(null)

const sortableId = computed(() => {
  if (props.rookie.id) {
    return String(props.rookie.id)
  }
  return `local-${props.rookie.image_id}-${props.rookie.day}-${props.index}`
})

const { isDragging, isDropTarget } = useSortable({
  id: () => sortableId.value,
  index: () => props.index,
  group: () => props.group,
  element,
  handle,
  transition: null,
})

function onClick() {
  emit('select')
}
</script>

<template>
  <div
    ref="element"
    class="rookie-drag-item handle"
    :class="{
      'is-dragging': isDragging,
      'is-drop-target': isDropTarget,
      'is-selected': selected,
    }"
    @click="onClick"
  >
    <div ref="handle" class="rookie-drag-handle">
      <el-image
        lazy
        style="height: 160px"
        :src="`${cdnUrl}/${rookie.thumbnail}`"
      />
    </div>
    <span v-if="selected" class="rookie-selected-badge">已选</span>
    <el-icon
      style="position: absolute; top: 5px; right: 5px; cursor: pointer"
      @click.stop="emit('remove', rookie)"
    >
      <CircleClose />
    </el-icon>
  </div>
</template>

<style scoped>
.rookie-drag-item {
  display: inline-flex;
  position: relative;
  margin: 5px;
  padding: 2px;
  border: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  vertical-align: top;
}

.rookie-drag-item.is-selected {
  border-color: var(--el-color-primary);
  background: var(--el-color-primary-light-9);
}

.rookie-drag-item.is-dragging {
  opacity: 0.35;
}

.rookie-drag-item.is-drop-target::before {
  content: '';
  position: absolute;
  left: -3px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--el-color-primary);
  pointer-events: none;
  z-index: 10;
  border-radius: 1px;
}

.rookie-selected-badge {
  position: absolute;
  left: 6px;
  top: 6px;
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--el-color-primary);
  color: var(--el-color-white);
  font-size: 12px;
  line-height: 18px;
  pointer-events: none;
}

.rookie-drag-handle {
  cursor: grab;
}

.rookie-drag-handle:active {
  cursor: grabbing;
}
</style>
